export interface AnalyticsState {
  currentPage: string;
}

export const defaultState: AnalyticsState = {
  currentPage: "",
};
